// extracted by mini-css-extract-plugin
export default {"header":"MHeader_header__Iis2D","leftIcon":"MHeader_leftIcon__0OY9f","title":"MHeader_title__Gne4t","back":"MHeader_back__pTXn6","extra":"MHeader_extra__ZhOJ+"};